<template>
  <layout-editor-page
    :title="formTitle"
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="isAvailableToSave"
    :isCancel="!isAvailableToSave"
    @command="setCommand"
  >
    <form-employees
      :data="data"
      :model="formModel"
      @change="handleFormData"
      @updateModelItem="handlerUpdateModelItem"
      :hasCreateNew="hasCreateNew"
      ref="Form"/>
    <template v-slot:footer>
      <form-controls
        :isDelete="hasCreateNew"
        :isCreate="!hasCreateNew"
        :isSave="hasCreateNew"
        class="form-footer"
        @command="setCommand"/>
    </template>
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'

export default {
  name: 'EditorEmployees',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'form-employees': () => import(/* webpackChunkName: 'Employees' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'Employees/Patch/${data.id}'
    }
  },
  computed: {
    formTitle () {
      return this.formData.name || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        name: '',
        userPath: '',
        isActive: true
      }
    }
  }
}
</script>

<style lang="stylus">
</style>
